import React from "react";
import dayjs from "dayjs";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimeField } from "@mui/x-date-pickers/TimeField";
import { EDITING_STATE, PALETTE } from "../constants";

const { CANCEL_EDIT_QUEUED, CONFIRM_EDIT_QUEUED, IS_EDITING } = EDITING_STATE;

const TIMER_UNDERLINE_OFFSET = {
  modal: "31%",
  game: "31%",
  discuss: "20%",
};

const TimerDisplay = ({
  time,
  setIsGamePlaying,
  setIsPaused,
  setEditingState,
  setTimerDuration,
  timerType,
  showTextDecoration,
  disableEditing,
}) => {
  const handleFocus = () => {
    setIsGamePlaying(false);
    setTimerDuration(time);
    setIsPaused(true);
    setEditingState(IS_EDITING);
  };

  const handleBlur = () => {
    setEditingState((state) =>
      state === CANCEL_EDIT_QUEUED ? CANCEL_EDIT_QUEUED : CONFIRM_EDIT_QUEUED
    );
  };

  const handleChange = (value) => {
    if (value?.isValid()) {
      setTimerDuration(value.unix());
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      setEditingState(CANCEL_EDIT_QUEUED);
      e.target.blur();
    } else if (e.key === "Enter") {
      e.target.blur();
    } else if (e.key === "Tab") {
      // manually editing the selection seems to mess with the internal <TimeField /> logic =\
      /* //
      const { selectionStart, selectionEnd } = e.target;
      if (selectionStart <= 2 && selectionEnd <= 2) {
        e.target.setSelectionRange(3, 5);
      } else if (selectionStart >= 3 && selectionEnd >= 3) {
        e.target.setSelectionRange(0, 2);
      }
      // */

      // prevent moving to next input
      e.preventDefault();
    }
    e.stopPropagation();
  };

  const style = {
    maxWidth: "inherit",
    maxHeight: "inherit",
    color: "inherit",
    fontFamily: "inherit",
    fontWeight: "inherit",
    fontSize: "inherit",
    textUnderlineOffset: TIMER_UNDERLINE_OFFSET[timerType],
    textDecoration:
      showTextDecoration && `2px underline ${PALETTE.underlineGray}`,
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimeField
        name="mmss"
        value={dayjs.unix(time)}
        format="mm:ss"
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        variant="standard"
        disabled={disableEditing}
        InputProps={{
          disableUnderline: true,
          style,
        }}
        // passes attribute to input
        inputProps={{
          className: "mmss",
        }}
        sx={{
          "& .MuiInputBase-input.Mui-disabled": {
            // Mui updates input color using webkit text fill color and not color
            // https://github.com/mui/material-ui/blob/821784419eefb89e4ce7b66c4b602a1e33d2fa88/packages/mui-material/src/InputBase/InputBase.js#L212
            WebkitTextFillColor: "inherit",
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default TimerDisplay;
